import { type ReactElement } from 'react'
import { Controller, type FieldValues } from 'react-hook-form'

import KNAdvancedDropdown from 'components/KNAdvancedDropdown/KNAdvancedDropdown'
import { getFieldErrorMessages } from 'global/helpers/form'
import type { KNFormDropdownProps } from './types'

const KNFormDropdown = <T extends FieldValues>({
  name,
  control,
  rules,
  label,
  options,
  multiple,
  size,
  sx,
  disabled,
}: KNFormDropdownProps<T>): ReactElement => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { onChange, value, name, ref }, fieldState: { invalid, error }, formState }): ReactElement => (
      <KNAdvancedDropdown
        fullWidth
        label={label}
        size={size}
        sx={sx}
        disabled={formState.isSubmitting || disabled}
        inputRef={ref}
        value={value}
        onChange={(newValue): void => {
          onChange(newValue)
        }}
        options={options}
        multiple={multiple}
        error={invalid}
        helperText={getFieldErrorMessages(error)}
      />
    )}
  />
)

export default KNFormDropdown
